module.exports = __webpack_public_path__ + "img/landing_page.14300537.png";